
class Main_Processor {
    /**
    * @name StoreMapList     
    * @summary Returns list of objects used in the module
    * @return {Array} Array of object list
    */
    static StoreMapList() {
        return [
            { "StoreKey": "ApplicationState", "DataKey": "LoggedIn" }
        ];
    }
}

export default Main_Processor;